module.exports = __webpack_public_path__ + "img/secure.038de62.svg";